import React, { FC } from 'react';
import { unicodesMap } from 'shared/components/icons/unicodesMap';
import { SimpleIcon } from 'shared/components/icons/icons';
import styles from './index.module.scss';

const icons = Object.keys(unicodesMap);

type TProps = {
  onClick: (icon: keyof typeof unicodesMap) => void;
};

const ListOfIcons: FC<TProps> = ({ onClick }) => {
  return (
    <div className={styles['icons-list']}>
      {icons.map(symbol => (
        <div className={styles.icon} onClick={() => onClick(symbol as keyof typeof unicodesMap)}>
          <SimpleIcon name={symbol as keyof typeof unicodesMap} />
        </div>
      ))}
    </div>
  );
};

export default ListOfIcons;
